import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import Icon from "@mui/material/Icon";

/** Shared glyph size so the home icon and page name stay in lockstep. */
const BREADCRUMB_SIZE = 22;
const COMPACT_BREADCRUMB_SIZE = 18;

function Breadcrumbs({ icon, title, light = false, darkMode = false, compact = false }: any) {
  const { t } = useTranslation();
  const color = light || darkMode ? "white" : "text.primary";
  const colorSx = {
    color: light || darkMode ? "white !important" : "text.primary !important",
  };
  const glyphSize = compact ? COMPACT_BREADCRUMB_SIZE : BREADCRUMB_SIZE;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        gap: compact ? 1 : 0.75,
        height: "100%",
        minHeight: glyphSize,
        minWidth: 0,
        maxWidth: "100%",
        fontSize: glyphSize,
        lineHeight: 1,
        mr: 0,
      }}
    >
      {compact ? null : (
      <Box
        component={Link}
        to="/"
        aria-label={t("common.home")}
        sx={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          width: glyphSize,
          height: glyphSize,
          lineHeight: 0,
          textDecoration: "none",
          color: "inherit",
          "&:hover, &:visited, &:focus": {
            textDecoration: "none",
            color: "inherit",
          },
        }}
      >
        <Icon
          sx={{
            fontSize: `${glyphSize}px !important`,
            width: glyphSize,
            height: glyphSize,
            lineHeight: 1,
            display: "block",
            ...colorSx,
          }}
        >
          {icon}
        </Icon>
      </Box>
      )}
      <Typography
        component="span"
        fontWeight={400}
        textTransform="capitalize"
        color={color}
        noWrap
        sx={{
          fontSize: glyphSize,
          lineHeight: 1.2,
          letterSpacing: "-0.01em",
          fontWeight: compact ? 600 : 400,
          overflow: "hidden",
          textOverflow: "ellipsis",
          minWidth: 0,
          ...colorSx,
        }}
      >
        {title.replace("-", " ")}
      </Typography>
    </Box>
  );
}

Breadcrumbs.propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  route: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  light: PropTypes.bool,
  darkMode: PropTypes.bool,
  compact: PropTypes.bool,
};

export default Breadcrumbs;
